import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  TextField,
  InputAdornment,
} from "@mui/material";
import { Search } from "@mui/icons-material";

const Report = () => {
  return (
    <Box
  sx={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    p: 3,
    backgroundColor: "white",
  }}
>
 
  <Box sx={{ width: "100%", maxWidth: "100%", mb: 4, display: "flex", justifyContent: "flex-start" }}>
    <TextField
      placeholder="Search by order id"
      variant="outlined"
      size="small"
      sx={{ width: "300px" }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
    />
  </Box>
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      gap: 4,
      width: "80%",
      justifyContent: "center",
    }}
  >
    <Card
      variant="outlined"
      sx={{
        p: 3,
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        borderRadius: "15px",
      }}
    >
      <CardContent>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Income Statement
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          View or generate income statements for specific periods.
        </Typography>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#0F6157",
            borderRadius: "20px",
            textTransform: "none",
          }}
        >
          Generate Report
        </Button>
      </CardContent>
    </Card>
    <Card
      variant="outlined"
      sx={{
        p: 3,
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        borderRadius: "15px",
      }}
    >
      <CardContent>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Balance Sheet
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Access the current balance sheet or generate for past periods.
        </Typography>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#0F6157",
            borderRadius: "20px",
            textTransform: "none",
          }}
        >
          Generate Report
        </Button>
      </CardContent>
    </Card>
    <Card
      variant="outlined"
      sx={{
        p: 3,
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        borderRadius: "15px",
      }}
    >
      <CardContent>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Cash Flow Statement
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          View or generate cash flow statements for specific periods.
        </Typography>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#0F6157",
            borderRadius: "20px",
            textTransform: "none",
          }}
        >
          Generate Report
        </Button>
      </CardContent>
    </Card>
  </Box>
</Box>

  );
};

export default Report;
